import { Component } from '@angular/core';
import { Modal } from 'bootstrap';

import { MapService } from '../map.service';

@Component({
	selector: 'app-map-city',
	templateUrl: './map-city.component.html',
	styleUrls: ['./map-city.component.css'],
})
export class MapCityComponent {
	constructor(public service: MapService) {}

	open(): void {
		new Modal(document.getElementById('cityModal')).show();
	}

	close(): void {
		const modal = Modal.getInstance(document.getElementById('cityModal'));
		if (!modal) {
			return;
		}
		modal.close();
	}

	boarding(destination): void {
		this.service.boarding(destination, this.service.citySelected, this.service.vehicleSelected);
	}

	dropoff(destination): void {
		this.service.dropoff(destination, this.service.vehicleSelected, this.service.citySelected);
	}

	cruising(): void {
		this.service.cruising(
			this.service.citySelected.destination,
			this.service.vehicleSelected,
			this.service.citySelected,
		);
	}
}
